function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { createBreakpointMap } from '../helpers/styled-helpers';
import { IconOutputPathContext } from '../contexts';
import { inlineSVGIcons, svgIcons } from './icons';
import { getStyledInlineSvgIcon, StyledIMG } from './style';

var Icon = iconProps => {
  var theme = useContext(ThemeContext);
  var outputPath = useContext(IconOutputPathContext).outputPath;

  var {
    icon,
    width,
    height,
    alt = '',
    expands,
    className = '',
    changeColorOnHoverAndActiveStates
  } = iconProps,
      styledSystemProps = _objectWithoutProperties(iconProps, ["icon", "width", "height", "alt", "expands", "className", "changeColorOnHoverAndActiveStates"]);

  var expandsMap = expands ? createBreakpointMap(expands) : undefined;
  var widthMap = width ? createBreakpointMap(width) : undefined;
  var heightMap = height ? createBreakpointMap(height) : undefined;

  if (icon in inlineSVGIcons) {
    var StyledInlineSVG = getStyledInlineSvgIcon(icon);
    return /*#__PURE__*/React.createElement(StyledInlineSVG, _extends({
      className: className,
      expandsMap: expandsMap,
      widthMap: widthMap,
      heightMap: heightMap,
      changeColorOnHoverAndActiveStates: changeColorOnHoverAndActiveStates
    }, styledSystemProps));
  }

  var neutralIconName = "Neutral".concat(icon);
  var iconName = theme.useNeutralColorScheme && svgIcons[neutralIconName] ? neutralIconName : icon;
  return /*#__PURE__*/React.createElement(StyledIMG, _extends({
    className: className,
    alt: alt,
    src: "".concat(outputPath, "/").concat(svgIcons[iconName]),
    expandsMap: expandsMap,
    widthMap: widthMap,
    heightMap: heightMap,
    changeColorOnHoverAndActiveStates: changeColorOnHoverAndActiveStates
  }, styledSystemProps));
};

export default Icon;